const productMobile = {
  path: "",
  name: "",
  redirect: "/productmobile",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/productmobile",
      redirect: "/productmobile",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Product Mobile",
      meta: {
        requiresAuth: true,
        activeUrl: "/productmobile",
        parent: "productmobile",

        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/product/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/productmobile",
            parent: "Product Mobile",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Product Mobile Detail",
          component: () => import("@/views/pages/product/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/productmobile",
            parent: "productmobile",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default productMobile;
